import { useContext } from 'react';
import { PrivacyContext } from 'src/contexts/privacy/PrivacyContext';

// ----------------------------------------------------------------------

const usePrivacyContext = () => useContext(PrivacyContext);

export default usePrivacyContext;